import { API_v2 } from '@/services/config';
import { request } from '@@/exports';

/**
 * 获取用户绑定的公司列表/项目列表 ( list )
 * @param params
 * @param options
 */
export async function getPlatformListToUid(
  params: {
    page?: number;
    pageSize?: number;
    platform_id: number | string;
    company_id?: number | string; // 存在则查询公司下项目,否则查询全部项目
    query_all?: number;
    company_name?: number | string;
    show?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getCompanyListToUid, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 获取公司列表( table )
 * @param params
 * @param options
 */
export async function getCompanyListToTable(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    company?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getCompanyList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 *   修改公司信息
 * @param data
 * @param options
 */
export async function editCompany(data: Company, options?: { [key: string]: any }) {
  // 延时函数，返回一个 Promise，在指定时间后 resolve
  const delay = (ms: number) =>
    new Promise((resolve) => {
      setTimeout(() => resolve(true), ms);
    });

  // 模拟延时，比如延时 2 秒（2000 毫秒）
  await delay(3000);
  // 执行实际的 API 请求
  return request(API_v2.editCompany, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 新增公司
 * @param data
 * @param options
 */
export async function addCompany(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addCompany, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除公司
 * @param data
 * @param options
 */
export async function delCompany(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.delCompany, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

//公司资料接口
/**
 * 获取公司资料列表( table )
 * @param params
 * @param options
 */
export async function getCompanyInfoList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getCompanyInfoList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 *   修改公司信息
 * @param data
 * @param options
 */
export async function editCompanyInfo(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editCompanyInfo, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 新增公司资料
 * @param data
 * @param options
 */
export async function addCompanyInfo(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addCompanyInfo, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除公司资料
 * @param data
 * @param options
 */
export async function delCompanyInfo(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_info_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delCompanyInfo, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

//人员证书接口
/**
 * 获取人员证书列表( table )
 * @param params
 * @param options
 */
export async function getPersonCertList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getPersonCertList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 *   修改人员证书信息
 * @param data
 * @param options
 */
export async function editPersonCert(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editPersonCert, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 新增人员证书
 * @param data
 * @param options
 */
export async function addPersonCert(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addPersonCert, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除人员证书
 * @param data
 * @param options
 */
export async function delPersonCert(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    person_cert_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delPersonCert, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取员工列表不分页
 * @param params
 * @param options
 */
export async function getCompanyPersonnelList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
    query_all?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getCompanyPersonnelList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
//文书收发记录
/**
 * 获取文书收发记录列表( table )
 * @param params
 * @param options
 */
export async function getDocumentLendVoucherList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getDocumentLendVoucherList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 查看借出单附件列表
 * @param params
 * @param options
 */
export async function getDocumentLendGoodsWithFiles(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
    voucher_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getDocumentLendGoodsWithFiles, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *   修改文书记录
 * @param data
 * @param options
 */
export async function editDocumentLendVoucher(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editDocumentLendVoucher, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 新增文书记录
 * @param data
 * @param options
 */
export async function addDocumentLendVoucher(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addDocumentLendVoucher, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 查询借出单附件详情
 * @param params
 * @param options
 */
export async function getDocumentLendGoodsList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    voucher_id?: number;
    is_return?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getDocumentLendGoodsList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 全部归还
 * @param data
 * @param options
 */
export async function batchReturn(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    voucher_id?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.batchReturn, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 部分归还
 * @param data
 * @param options
 */
export async function sectionReturn(data: any, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.sectionReturn, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
//企业资质
/**
 * 获取企业资质列表( table )
 * @param params
 * @param options
 */
export async function getCompanyQualificationList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getCompanyQualificationList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *   修改企业资质信息
 * @param data
 * @param options
 */
export async function editCompanyQualification(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editCompanyQualification, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 新增企业资质
 * @param data
 * @param options
 */
export async function addCompanyQualification(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addCompanyQualification, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除企业资质
 * @param data
 * @param options
 */
export async function delCompanyQualification(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delCompanyQualification, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *   设置公司税率
 * @param data
 * @param options
 */
export async function setCompanyLocalTax(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.setCompanyLocalTax, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
